import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface DeletePerformanceParams {
  actId: string;
  performanceId: string;
}

export const deletePerformanceAPI = async ({
  actId,
  performanceId,
}: DeletePerformanceParams) => {
  const response = await baseAPI.delete(
    `/acts/${actId}/performances/${performanceId}`,
  );
  return response.data;
};

export const useDeletePerformanceMutation = () => {
  return useMutation({
    mutationFn: async (params: DeletePerformanceParams) => {
      return await deletePerformanceAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
    },
  });
};
